<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <header
    data-slot="section-header"
    :class="
      cn('grid w-full grid-cols-1 gap-x-5 lg:has-data-[slot=section-header-actions]:grid-cols-[1fr_auto]', props.class)
    "
  >
    <slot />
  </header>
</template>
